import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchPaymentHistory } from "../../../../shared/hooks/useFetchPaymentHistory";
import API_URLS from "../../Utils/axr";
import { errorConditionGTM } from "../../Utils/googleTags";
import store from "../store";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import DwLogutil from "../../Utils/DwLogutil";

type paymentHistoryInitialStateType = {
  paymentHistory: any;
  loading: boolean;
  error: any;
};
const initialState: paymentHistoryInitialStateType = {
  paymentHistory: null,
  loading: false,
  error: null,
};

export const getPaymentHistory = createAsyncThunk(
  "payment/history",
  async (billingAccountNumber: string) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      let url=API_URLS['paymentHistoryUrl_QA_URL']
      const response = await fetchPaymentHistory(
        {
          [url]: billingAccountNumber,
        },
        headers
      );
      if(response?.data?.payments !== null) {
        for(const payment of response?.data?.payments) {
          if( !payment?.invoice?.[0]?.invoiceId ){
            DwLogutil({stepName: EC_DW_LOGGING_STEPS.payment_history_api_data_incorrect, error: 'invoiceId not found'})  
            return response?.data
          }
        }
      }
      return response.data
    } catch (error) {
      throw error;
      
    }
  }
);

const paymentHistorySlice = createSlice({
  name: "payment/history",
  initialState,
  reducers: {
    clearPaymentHistorySlice: (state) => {
      return initialState;
    },
    paymentHistorySliceSetInitialState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getPaymentHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPaymentHistory.fulfilled, (state, action) => {
      state.paymentHistory = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getPaymentHistory.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "payment history",
        action.error?.message,
        action?.type
      );
      state.paymentHistory = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const { clearPaymentHistorySlice, paymentHistorySliceSetInitialState } =
  paymentHistorySlice.actions;
export default paymentHistorySlice.reducer;
